import { UrlConstants } from "../url.constants";
export class ApiDemolitionManagementConstants {
    static URL = UrlConstants.API_V2 + "DemolitionManagement";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetDemolitionManagementProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateDemolitionManagementInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalDemolitionManagementApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetDemolitionManagementRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "GetDmApplicationTypes";
}
